// import { dehydrate } from "store/slices/auth.slice";
// import store from "store/store";
import constant from "config/constant";

import ls from "util/secureStorage";

const autoSignOut = (status, error, redux = false) => {
  if (
    (status === 403 &&
      error &&
      String(error).toLowerCase().includes("unauthorized")) ||
    (error && String(error).toLowerCase().includes("token invalid"))
  ) {
    // if (redux) {
    //   store.dispatch(dehydrate());
    // } else {
    ls.clear();
    // }
    const redirectUrl = window.location.pathname;
    if (redirectUrl && redirectUrl !== constant.PAGES.LOGIN) {
      window.location.replace(
        `${constant.PAGES.LOGIN}?redirectUrl=${redirectUrl}`
      );
    } else if (window.location.pathname !== constant.PAGES.LOGIN) {
      window.location.replace(constant.PAGES.LOGIN);
    }
  }
};

export default autoSignOut;
